/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";

export const Spreadsheet = ({ spreadsheetData }: any) => {
  const [rows, setRows] = useState<any[][]>([]);
  const [sheetname, setSheetname] = useState<any[]>([]);
  const [activeSheetname, setActiveSheetname] = useState<number>(0);

  useEffect(() => {
    if (spreadsheetData) {
      setSheetname(spreadsheetData.SheetNames);
      loadTableData();
    }
  }, [spreadsheetData]);

  useEffect(() => {
    if (spreadsheetData) {
      loadTableData();
    }
  }, [activeSheetname]);

  const loadTableData = () => {
    const firstSheetName = spreadsheetData.SheetNames[activeSheetname];
    const worksheet = spreadsheetData.Sheets[firstSheetName];

    const json = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
    }) as any[][]; // 2D array
    setRows(json);
  };

  return (
    <div className="border mb-2 rounded-md">
      {rows.length > 0 && (
        <div className="overflow-auto border rounded shadow h-[calc(700px_-_54px)] text-[14px] ">
          <table className="min-w-full table-auto border-collapse">
            <thead className="bg-gray-100 sticky top-0">
              <tr>
                {rows[0].map((cell, index) => (
                  <th
                    key={index}
                    className="border border-gray-300 px-4 py-2 text-left font-semibold text-[14px]"
                  >
                    <span className="inline-block min-w-max text-[rgb(148,163,184]">
                      {cell}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.slice(1).map((row, rowIndex) => {
                const diff = rows[0].length - row.length;
                const newArray = Array(diff).fill(diff);
                return (
                  <tr key={rowIndex} className="odd:bg-white even:bg-gray-50">
                    {row.map((cell, colIndex) => {
                      return (
                        <td
                          key={`data-${colIndex}-${rowIndex}`}
                          className="border border-gray-200 px-4 py-2 text-[14px]"
                        >
                          <span className="inline-block min-w-max max-w-[300px] text-[rgb(71,85,105)]">
                            {cell?.toString() || "-"}
                          </span>
                        </td>
                      );
                    })}
                    {newArray?.map((_cell, colIndex) => {
                      return (
                        <td
                          key={colIndex}
                          className="border border-gray-200 px-4 py-2 text-[14px]"
                        >
                          <span className="inline-block min-w-max max-w-[300px] text-[rgb(71,85,105)]"></span>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="flex">
        {sheetname?.map((item: string, index: number) => {
          return (
            <div
              key={index}
              className={cn(
                "border px-3 py-2 text-sm cursor-pointer",
                index === activeSheetname && "bg-gray-100"
              )}
              onClick={() => setActiveSheetname(index)}
            >
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};
